import { FactoryProvider } from '@angular/core';
import { ApiConfig, Settings } from '@mri-platform/shared/core';

export const ApiConfigProvider: FactoryProvider = {
  provide: ApiConfig,
  useFactory: (settings: Settings) => new ApiConfig(settings.api),
  deps: [Settings]
};
